<template>

<div>




<app-navigator  @typeChenge="ParsContent = $event" :leftMenu='leftMenu' > </app-navigator>


     <v-container fluid  >
     <router-view></router-view>
     </v-container>

</div>

</template>

<script>

import axios from 'axios'

 
export default {
  data () {
    return {
      leftMenu: {
        title: "Парсер",
        items: [
         {id:1,name:"Поиск сообществ", icon:"mdi-account-group", iconColor:"green", content:"parser_groups", selected:false },
         {id:2,name:"Поиск страниц", icon:"mdi-account-search", iconColor:"#273C51", content:"pages_search", selected:true },
         {id:3,name:"Поиск видео", icon:"mdi-file-video",iconColor:"red", content:"pars_video", selected:false },
         {id:4,name:"Парсер обсуждений",icon:"mdi-comment-processing-outline",iconColor:"yellow", content:"pars_topics", selected:false },
         {id:5,name:"Парсер постов",icon:"mdi-comment-multiple-outline",iconColor:"pink", content:"pars_posts", selected:false },
         {id:7,name:"Парсер страниц", icon:"mdi-target", iconColor:"#273C51", content:"parser_pages", selected:false },

         {content:"line"},

         {id:8,name:"Фильтры", icon:"mdi-filter", iconColor:"#18E4FF", content:"filters", selected:false },
         {id:9,name:"Мои процессы",icon:"mdi-content-save", iconColor:"#7218FF", count: "processes",  content:"history", selected:false },

        ]
      }



    }
  },


 mounted (){
 console.log(this.$route)
 this.$route.path === '/' ? this.$router.push('/parser') :
 this.$store.dispatch('changeCounters')
 }
}
</script>

<style>
#toUp {
  padding-left: 15px;
  z-index: -1;
  position: fixed;
  margin-left: -10px;
  width: 115px;
  height: 100vh;
  color: #466a94;
}
#toUp:hover {
background-color: #DCE2E8
}

</style>
